import { IBreadcrumb } from '@models/IBreadcrumb';
import { IProductPageContent } from '@models/IProductPageContent';
import axios from 'axios';
import qs from 'qs';

interface Params {
  readonly getDynamicContentByMaterialCodeEndpoint: string;
  readonly language: string;
  readonly materialCode: string;
}

const getDynamicContent = async ({
  getDynamicContentByMaterialCodeEndpoint,
  language,
  materialCode,
}: Params): Promise<IProductPageContent> => {
  const query = qs.stringify({
    language,
    materialCode,
  });

  const { data } = await axios.get<IProductPageContent>(
    `${getDynamicContentByMaterialCodeEndpoint}?${query}`
  );

  return data;
};

export default getDynamicContent;
